import {
  GET_EDUCATION,
  GET_EDUCATION_SUCCESS,
  GET_EDUCATION_FAIL,
  DELETE_EDUCATION,
  DELETE_EDUCATION_SUCCESS,
  DELETE_EDUCATION_FAIL,
  UPDATE_EDUCATION,
  UPDATE_EDUCATION_SUCCESS,
  UPDATE_EDUCATION_FAIL,
  ADD_NEW_EDUCATION,
  ADD_EDUCATION_SUCCESS,
  ADD_EDUCATION_FAIL,
  EDUCATION_LOADING,
  EDUCATION_RESET,
} from "./actionType";

export const resetEducationState = (actionType) => ({
  type: EDUCATION_RESET,
  payload: { actionType },
});

export const getEducationSuccess = (actionType, data) => ({
  type: GET_EDUCATION_SUCCESS,
  payload: { actionType, data },
});

export const getEducationFail = (actionType, error) => ({
  type: GET_EDUCATION_FAIL,
  payload: { actionType, error },
});

export const getEducation = data => ({
  type: GET_EDUCATION,
  payload: data,
});

export const getEducationLoading = () => ({
  type: EDUCATION_LOADING
});

export const deleteEducation = data => ({
  type: DELETE_EDUCATION,
  payload: data,
});

export const deleteEducationSuccess = data => ({
  type: DELETE_EDUCATION_SUCCESS,
  payload: data,
});

export const deleteEducationFail = error => ({
  type: DELETE_EDUCATION_FAIL,
  payload: error,
});

export const updateEducation = data => ({
  type: UPDATE_EDUCATION,
  payload: data,
});

export const updateEducationFail = error => ({
  type: UPDATE_EDUCATION_FAIL,
  payload: error,
});

export const updateEducationSuccess = data => ({
  type: UPDATE_EDUCATION_SUCCESS,
  payload: data,
});

export const addNewEducation = data => ({
  type: ADD_NEW_EDUCATION,
  payload: data,
});

export const addEducationSuccess = data => ({
  type: ADD_EDUCATION_SUCCESS,
  payload: data,
});

export const addEducationFail = error => ({
  type: ADD_EDUCATION_FAIL,
  payload: error,
});